<template>
  <div class="custom-card">
    <div class="custom-card-tag" v-if="tagText != null">{{ tagText }}</div>
    <div class="custom-card-content flex-row">
      <div v-if="showChecked">
        <el-checkbox v-model="checked" @change="(value) => handleCardClick('checked', value)"></el-checkbox>
      </div>
      <div class="custom-card-left ml10px">
        <i v-if="!avatarUrl" :class="customCardLeft"></i>
        <div v-if="avatarUrl" class="avatar">
          <el-image :src="avatarUrl"></el-image>
        </div>
      </div>
      <div class="flex-auto ml10px">
        <slot name="content"></slot>
      </div>
    </div>
    <div class="custom-card-footer">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomCard",
  install(Vue) {
    Vue.component("CustomCard", this);
  },
  props: {
    customCardLeft: {
      type: String,
      default: "ri-account-circle-fill",
    },
    avatarUrl: {
      type: String,
      default: null,
    },
    isChecked: {
      type: Boolean,
      default: false,
    },
    showChecked: {
      type: Boolean,
      default: false,
    },
    tagText: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      checked: this.isChecked,
    };
  },
  methods: {
    handleCardClick(part, value) {
      this.$emit("cardClick", part, value);
    },
  },
};
</script>

<style scoped lang="scss">
.custom-card {
  position: relative;
  border: 1px solid #e3e3e3;
  border-radius: 5px;
  box-shadow: 1px 1px 3px #e5e5e5;
  padding: 10px;
  cursor: default;

  .custom-card-tag {
    position: absolute;
    border-radius: 0 5px 0 40px;
    padding: 0 20px;
    right: 0;
    top: 0;
    height: 40px;
    line-height: 40px;
    font-size: 12px;
    font-weight: 700;
    background-color: #d40303;
    color: white;
  }

  .custom-card-content {
    margin-bottom: 10px;

    .custom-card-left {
      display: flex;
      align-items: center;

      i {
        font-size: 80px;
        color: #1a70cc;
      }

      .avatar {
        width: 80px !important;
        height: 80px !important;
        border-radius: 50%;
        overflow: hidden;

        img {
          width: 100%;
          height: 100%;
          display: block;
        }

        ::v-deep .el-image {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }
  }

  .custom-card-footer {
    //position: relative;
    //right: 0;
    //bottom: 0;
    //left: 0;
    //height: 30px;
    //line-height: 30px;
  }
}
</style>
